import React, { useState } from "react";
import ServicesData from "./services.json";
import ImagePopup from "../../imageComponents/image-popup";
import ScrollToTopOnMount from "../../scrollComponents/ScrollToTopOnRoute";

const Services = () => {
  const [popupImage, setPopupImage] = useState(null);

  return (
    <div className="px-6 py-12 relative">
      <ScrollToTopOnMount />

      {/* Section Heading */}
      <h2 className="text-3xl md:text-4xl font-[Lora] font-bold text-[#2c7b2f] text-center mb-10">
        Our Services
      </h2>

      {/* Services Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
        {ServicesData.map((service, idx) => (
          <div
            key={idx}
            className="bg-white rounded-xl shadow-lg overflow-hidden transform hover:scale-105 hover:shadow-2xl transition duration-300 flex flex-col"
          >
            {/* Image */}
            <div
              className="w-full aspect-[16/9] overflow-hidden cursor-pointer"
              onClick={() => setPopupImage(service.imagePath)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) =>
                e.key === "Enter" && setPopupImage(service.imagePath)
              }
            >
              <img
                src={service.imagePath}
                alt={service.title}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Content */}
            <div className="p-6 flex flex-col flex-grow">
              <h3 className="font-[Lora] font-bold text-[#2c7b2f] text-xl text-center mb-4">
                {service.title}
              </h3>
              <p className="text-gray-700 text-base mb-4">{service.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Image Popup Modal */}
      <ImagePopup
        imageSrc={popupImage}
        altText="Service Image"
        onClose={() => setPopupImage(null)}
      />
    </div>
  );
};

export default Services;
